import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Collapse, Modal, ProgressBar } from "react-bootstrap";
import { fetchBus } from "redux/logistics/specificBus";

import TrailerPackingPlan from "components/Buses/trailerPackingPlan/TrailerPackingPlan";
import "./styles.scss";

import { busesAPI } from "components/Apis/Buses";
import DancingDots from "components/UI/Atoms/loading.js/dancingDots/dancingDots";
import toast from "react-hot-toast";
import { closeModal } from "redux/navigation/modalStates";
import { BOLPrinter } from "components/Warehouse/modals/PrintBOL";
import BlankSpace from "components/UI/Atoms/BlankCell";

const DetailsModal = ({ isOpen, toggle, busId }) => {
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeModal());
    };

    const { bus, loading, error } = useSelector((state) => state.specificBus);


    useEffect(() => {
        if (busId) {
            dispatch(fetchBus(busId));
        }
    }, [busId, dispatch]);


    const [sectionsCollapseStatus, setSectionsCollapseStatus] = useState({
        packingPlan: true,
        notes: true,
        outgoingOrders: true,
    });

    // Run side effects when bus data changes
    useEffect(() => {

    }, [bus]);

    const [busSizeOptions, setBusSizeOptions] = useState([])
    useEffect(() => {
        if (busSizeOptions.length === 0) {
            busesAPI.getSizeOptions()
                .then(data => {
                    if (data) {
                        setBusSizeOptions(data);
                    }
                })
                .catch(error => {
                    console.error("Failed to fetch size options:", error);
                });
        }
    }, []);

    if (!bus) {
        return <></>;
    }

    const packingPlan = bus.packing_plan || {};

    return (
        <Modal show={isOpen} onHide={handleClose} className="bsModal details-modal" size="xl">
            <div className="modal-header">
                <div className="title-block">
                    <h5 className="modal-title">{loading ? <DancingDots /> :
                        <>
                            <span>{bus?.name}</span>
                        </>}</h5>
                    {
                        !loading && !error ? (
                            <div className="stop-route">
                                <span className="stop-label">Destinations</span>
                                {bus?.stops.map((stop, index) => (
                                    <React.Fragment key={`${stop}-${index}`}>
                                        <div className="stop-node">
                                            <span className="stop-dot" aria-hidden="true" />
                                            <span className="stop-name">{stop}</span>
                                        </div>
                                        {index !== bus.stops.length - 1 && (
                                            <span className="stop-connector" aria-hidden="true" />
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        ) :
                            <BlankSpace />
                    }
                </div>
                <button type="button" className="close" onClick={handleClose}>
                    <span>&times;</span>
                </button>
            </div>
            <div className="modal-body">
                {loading || !bus && <p>Loading...</p>}
                {error && <p className="text-danger">Error: {error}</p>}
                <div className="modal-two-col">
                    <section className="modal-section utilization-section">
                        <div className="section-header">
                            <h6>Utilization</h6>
                        </div>
                        <div className="stat-grid">
                            <div className="stat-block">
                                <div className="stat-icon info">
                                    <i className="fa fa-ruler-horizontal" aria-hidden="true"></i>
                                </div>
                                <div className="stat-metric">
                                    <div className="stat-label">
                                        <span>Length</span>
                                        <span className="stat-value">{packingPlan.length_used ?? 0} ({packingPlan.p_length_used ?? 0}%)</span>
                                    </div>
                                    <ProgressBar
                                        now={packingPlan.length_used || 0}
                                        variant={
                                            packingPlan.p_length_used > 90 ? "danger" :
                                                packingPlan.p_length_used > 70 ? "warning" :
                                                    "success"
                                        }
                                        className="compact-progress inline-progress"
                                    />
                                </div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-icon warning">
                                    <i className="fa fa-balance-scale" aria-hidden="true"></i>
                                </div>
                                <div className="stat-metric">
                                    <div className="stat-label">
                                        <span>Weight</span>
                                        <span className="stat-value">{bus.weight} ({bus.p_weight_used}%)</span>
                                    </div>
                                    <ProgressBar
                                        now={bus.p_weight}
                                        variant={
                                            bus.p_weight > 90 ? "danger" :
                                                bus.p_weight > 70 ? "warning" :
                                                    "success"
                                        }
                                        className="compact-progress inline-progress"
                                    />
                                </div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-icon">
                                    <i className="fa fa-th-large" aria-hidden="true"></i>
                                </div>
                                <div className="stat-metric">
                                    <div className="stat-label">
                                        <span>Area</span>
                                        <span className="stat-value">{packingPlan.area_used ?? 0} ({packingPlan.p_area_used ?? 0}%)</span>
                                    </div>
                                    <ProgressBar
                                        now={packingPlan.p_area_used || 0}
                                        variant={
                                            packingPlan.p_area_used > 90 ? "danger" :
                                                packingPlan.p_area_used > 70 ? "warning" :
                                                    "success"
                                        }
                                        className="compact-progress inline-progress"
                                    />
                                </div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-icon">
                                    <i className="fa fa-cube" aria-hidden="true"></i>
                                </div>
                                <div className="stat-metric">
                                    <div className="stat-label">
                                        <span>Volume</span>
                                        <span className="stat-value">{packingPlan.volume_used ?? 0} ({packingPlan.p_volume_used ?? 0}%)</span>
                                    </div>
                                    <ProgressBar
                                        now={packingPlan.p_volume_used || 0}
                                        variant={
                                            packingPlan.p_volume_used > 90 ? "danger" :
                                                packingPlan.p_volume_used > 70 ? "warning" :
                                                    "success"
                                        }
                                        className="compact-progress inline-progress"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="modal-section schedule-section">
                        <div className="section-header">
                            <h6>Schedule</h6>
                        </div>
                        {
                            !loading && bus && (
                                <div className="detail-grid">
                                    {
                                        (() => {
                                            const dockedOrders = bus.outgoing_orders.filter(order => order.dock.toLowerCase() == "yes");
                                            return (
                                                <div className="stat-block">
                                                    <div className="stat-icon success">
                                                        <i className="fa fa-anchor" aria-hidden="true"></i>
                                                    </div>
                                                    <div className="stat-label">
                                                        <span>Docked Orders</span>
                                                        <span className="stat-value">{dockedOrders.length}/{bus.outgoing_orders.length}</span>
                                                    </div>
                                                </div>
                                            );
                                        })()
                                    }
                                    <div className="stat-block compact">
                                        <div className="stat-icon">
                                            <i className="fa fa-cubes" aria-hidden="true"></i>
                                        </div>
                                        <div className="stat-label">
                                            <span>Skids</span>
                                            <span className="stat-value">{bus?.units}</span>
                                        </div>
                                    </div>
                                    <div className="stat-block compact">
                                        <div className="stat-icon">
                                            <i className="fa fa-clock" aria-hidden="true"></i>
                                        </div>
                                        <div className="stat-label">
                                            <span>Scheduled Pickup</span>
                                            <span className="stat-value">{bus.scheduled_pickup}</span>
                                        </div>
                                    </div>
                                    <div className="stat-block compact">
                                        <div className="stat-icon danger">
                                            <i className="fa fa-flag-checkered" aria-hidden="true"></i>
                                        </div>
                                        <div className="stat-label">
                                            <span>Drop Dead</span>
                                            <span className="stat-value">{bus.drop_dead}</span>
                                        </div>
                                    </div>
                                    <div className="stat-block compact">
                                        <div className="stat-icon info">
                                            <i className="fa fa-map-pin" aria-hidden="true"></i>
                                        </div>
                                        <div className="stat-label">
                                            <span>Destination(s)</span>
                                            <span className="stat-value">{bus.stops.map(stop => stop).join(', ')}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </section>

                    <section className="modal-section coverage-section">
                        <div className="section-header">
                            <h6>Coverage</h6>
                        </div>
                        {
                            !loading && bus && (
                                <div className="detail-grid coverage-grid">
                                    <div className="coverage-field">
                                        <label className="cell-label coverage-label">
                                            <i className="fa fa-user icon-inline" aria-hidden="true"></i>
                                            Driver
                                        </label>
                                        <input
                                            name='driver'
                                            type='text'
                                            className={`input super-thin bus-inline-input driver_${bus.bus_id}`}
                                            defaultValue={bus.driver}
                                            onBlur={(e) =>
                                                busesAPI.patch(bus.id, { driver: e.target.value })
                                                    .then(() => {
                                                        toast.success("Bus updated successfully!")
                                                    })
                                                    .catch((error) => {
                                                        toast.error(`Failed to update bus: ${error.message}`);
                                                    })
                                            }
                                        />
                                    </div>
                                    <div className="coverage-field">
                                        <label className="cell-label coverage-label">
                                            <i className="fa fa-truck icon-inline" aria-hidden="true"></i>
                                            Unit Size
                                        </label>
                                        <select
                                            name='trailer_size'
                                            className={`input super-thin bus-inline-input trailer_size_${bus.bus_id}`}
                                            defaultValue={bus.trailer_size}
                                            onChange={(e) =>
                                                busesAPI.patch(bus.id, { trailer_size: e.target.value })
                                                    .then(() => {
                                                        toast.success("Unit size updated successfully!")
                                                    })
                                                    .catch((error) => {
                                                        toast.error(`Failed to update unit size: ${error.message}`);
                                                    })
                                            }
                                        >
                                            {busSizeOptions.map((option) => (
                                                <option key={option} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )
                        }
                    </section>
                </div>
                {/* packing plan */}
                <section className="modal-section">
                    <div className="section-header">
                        <h6>Packing Plan</h6>
                        <button
                            type="button"
                            className="section-toggle"
                            onClick={() => setSectionsCollapseStatus(prev => ({ ...prev, packingPlan: !prev.packingPlan }))}>
                            {sectionsCollapseStatus.packingPlan ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                        </button>
                    </div>

                    <Collapse in={sectionsCollapseStatus.packingPlan}>
                        <div>
                            {bus && <TrailerPackingPlan busId={bus?.id} />}
                        </div>
                    </Collapse>
                </section>
                {
                    bus && bus.incoming_orders.length > 0 && (
                        <section className="modal-section">
                            <div className="section-header">
                                <h6>Incoming Orders</h6>
                                <button
                                    type="button"
                                    className="section-toggle"
                                    onClick={() => setSectionsCollapseStatus(prev => ({ ...prev, incomingOrders: !prev.incomingOrders }))}>
                                    {sectionsCollapseStatus.incomingOrders ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                                </button>
                            </div>
                        </section>
                    )
                }
                <section className="modal-section">
                    <div className="section-header">
                        <h6>Outgoing Orders</h6>
                        <button
                            type="button"
                            className="section-toggle"
                            onClick={() => setSectionsCollapseStatus(prev => ({ ...prev, outgoingOrders: !prev.outgoingOrders }))}>
                            {sectionsCollapseStatus.outgoingOrders ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                        </button>
                    </div>
                    <Collapse in={sectionsCollapseStatus.outgoingOrders}>
                        <table className="kpis-goals-table in-pulse-card w-100">
                            <thead>
                                <tr>
                                    <th>order</th>
                                    <th>Dock</th>
                                    <th>Weight</th>
                                    <th>Skids</th>
                                    <th>Dims</th>
                                    <th>Stackable</th>
                                    <th>Destination</th>
                                    <th>Deliver Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bus && bus.outgoing_orders.map((order) => (
                                    <tr key={order.id}>
                                        <td>{order.order_no}</td>
                                        <td>{order.dock}</td>
                                        <td>{order.weight}</td>
                                        <td>{order.units}</td>
                                        <td>{order.length}x{order.width}x{order.height}</td>
                                        <td>{order.stackable}</td>
                                        <td>{order.delivery_city_state}</td>
                                        <td>{order.delivery_date}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Collapse>
                </section>
                {
                    bus && bus.partials.length > 0 && (
                        <section className="modal-section">
                            <div className="section-header">
                                <h6>Partials</h6>
                                <button
                                    type="button"
                                    className="section-toggle"
                                    onClick={() => setSectionsCollapseStatus(prev => ({ ...prev, partials: !prev.partials }))}>
                                    {sectionsCollapseStatus.partials ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                                </button>
                            </div>
                            <Collapse in={sectionsCollapseStatus.partials}>
                                <table className="kpis-goals-table in-pulse-card w-100">
                                    <thead>
                                        <tr>
                                            <th>Order</th>
                                            <th>Weight</th>
                                            <th>Skids</th>
                                            <th>Dims</th>
                                            <th>Stackable</th>
                                            <th>Destination</th>
                                            <th>Deliver Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bus && bus.partials.map((partial) => (
                                            <tr key={partial.id}>
                                                <td>{partial.order.order_no} {partial.order.order_group}  {partial.order.pro_f}</td>
                                                <td>{partial.weight}</td>
                                                <td>{partial.quantity}/{partial.order.units}</td>
                                                <td>{partial.order.length}x{partial.order.width}x{partial.order.height}</td>
                                                <td>{partial.order.stackable}</td>
                                                <td>{partial.order.delivery_city_state}</td>
                                                <td>{partial.order.delivery_date}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Collapse>
                        </section>
                    )
                }
                <section className="modal-section">
                    <div className="section-header">
                        <h6>Notes</h6>
                        <button
                            type="button"
                            className="section-toggle"
                            onClick={() => setSectionsCollapseStatus(prev => ({ ...prev, notes: !prev.notes }))}>
                            {sectionsCollapseStatus.notes ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                        </button>
                    </div>
                    <Collapse in={sectionsCollapseStatus.notes}>
                        <div>
                            <textarea
                                className="bus-notes-textarea"
                                defaultValue={bus ? bus.pieces_left : ""}
                                onBlur={(e) => {
                                    if (bus) {
                                        busesAPI.patch(bus.bus_id, { pieces_left: e.target.value })
                                            .then(() => {
                                                toast.success("Notes updated successfully!")
                                            })
                                            .catch((error) => {
                                                toast.error(`Failed to update pieces left: ${error.message}`);
                                            })
                                    }
                                }}
                            />
                        </div>
                    </Collapse>
                </section>
            </div>
            <div className="modal-footer">
                <div className="footer-buttons">
                    <BOLPrinter
                        btnClass={'button square d-flex'}
                        bus={{ id: bus?.id }}
                    />
                    <button
                        className='button square d-flex'
                        title='Mark Bus as Dispatched'
                        onClick={() => {
                            busesAPI.load(bus_id)
                                .then(() => {
                                    dispatch(
                                        fetchActiveBusesForLane(tab.id)
                                    )
                                })
                        }}
                    >
                        <i className='fa fa-check' />
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DetailsModal;
